import fetcher from 'helpers/fetcher';
import { getCustomer } from 'helpers/customer';

const listeners = new Set();
let counts = { 0: {}, 1: {} };
let loading = null;

export function currentStoreId() {
	const id = Number(getCustomer().store_id);
	return id === 1 ? 1 : 0;
}

function emit() {
	listeners.forEach(fn => fn(counts));
}

export function refreshHomeClicks() {
	const req = fetcher('/index.php?route=common/home_stat');
	if (!req || !req.then) return Promise.resolve(counts);
	return req
		.then(res => (res && res.ok ? res.json() : null))
		.then(data => {
			const raw = data && data.clicks;
			if (raw && typeof raw === 'object') {
				counts = {
					0: raw[0] || raw['0'] || {},
					1: raw[1] || raw['1'] || {},
				};
				emit();
			}
			return counts;
		})
		.catch(() => counts);
}

export function subscribeHomeClicks(fn) {
	listeners.add(fn);
	fn(counts);
	if (!loading) loading = refreshHomeClicks();
	return () => listeners.delete(fn);
}

function clip(value) {
	return String(value || '').slice(0, 150);
}

function slug(value) {
	return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 48);
}

function zoneOf(el) {
	if (el.closest('.rn-footer')) return 'Подвал';
	if (el.closest('.mobile-menu, .mobile-catalog-menu')) return 'Меню';
	if (el.closest('.tn-top-rail, .rn-header, .mobile-header, .mobile-bottom-nav')) return 'Шапка';
	if (el.closest('.ant-modal, .city-confirm')) return 'Окно';
	if (el.closest('.checkout-form-sidebar, .checkout-address-section')) return 'Оформление';
	if (el.closest('.popular-product-card, .rn-product-card, .product-page')) return 'Товар';
	if (el.closest('.catalog-card, .catalog-section')) return 'Главная';
	if (el.closest('.category-section')) return 'Каталог';
	if (el.closest('.cart-section, .cart-page')) return 'Корзина';
	return '';
}

function keyFromText(el, prefix) {
	const labelled = el.querySelector && el.querySelector('[aria-label]');
	const text = slug(
		el.getAttribute('aria-label') ||
			el.getAttribute('title') ||
			(labelled && labelled.getAttribute('aria-label')) ||
			el.innerText ||
			''
	);
	const zone = zoneOf(el);
	if (text && zone) return clip(`${prefix}:${zone}:${text}`);
	if (text) return clip(`${prefix}:${text}`);
	const cls = typeof el.className === 'string' ? el.className : '';
	const one = cls.split(/\s+/).find(c => c && !c.startsWith('ant-'));
	return one ? clip(`${prefix}:${one}`) : null;
}

function keyFromHref(link) {
	const href = link.getAttribute('href') || '';
	if (!href || href === '#' || href.startsWith('javascript:')) return null;
	if (href.startsWith('tel:')) return clip(`tel:${href.replace(/\D/g, '')}`);
	if (href.startsWith('mailto:')) {
		return clip(`mail:${href.slice(7).split('?')[0].toLowerCase()}`);
	}
	try {
		const url = new URL(href, window.location.origin);
		const path = url.pathname.replace(/\/$/, '') || '/';
		if (url.origin === window.location.origin) return clip(`go:${path}`);
		return clip(`ext:${url.hostname}${path}`);
	} catch (e) {
		return null;
	}
}

export function keyFromElement(node) {
	if (!node || !node.getAttribute || node.closest('.home-click-layer')) return null;
	const own = node.getAttribute('data-click-key');
	if (own) return clip(own);
	if (node.matches('a[href]')) return keyFromHref(node) || keyFromText(node, 'a');
	if (node.matches('button, [role="menuitem"], [role="button"]')) {
		return keyFromText(node, 'btn');
	}
	if (node.matches('.quality-card')) return keyFromText(node, 'card');
	return null;
}

export function keyFromEvent(event) {
	const target = event.target;
	if (!target || !target.closest || target.closest('.slick-cloned')) return null;
	const control = target.closest(
		'a[href], button, [role="menuitem"], [role="button"], [data-click-key], .quality-card'
	);
	return control ? keyFromElement(control) : null;
}

export function hitHomeClick(key) {
	const req = fetcher('/index.php?route=common/home_stat/hit', {
		method: 'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		body: new URLSearchParams({ key }).toString(),
	});
	if (!req || !req.then) return;
	req
		.then(res => (res && res.ok ? res.json() : null))
		.then(data => {
			if (!data || typeof data.hits !== 'number') return;
			const city = Number(data.store_id) === 1 ? 1 : 0;
			counts = {
				...counts,
				[city]: { ...counts[city], [key]: data.hits },
			};
			emit();
		})
		.catch(() => {});
}
